import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

function opsPath(clientViewId, suffix, params) {
  return `/views/${clientViewId}/midpoint-media/${suffix}${buildClientQuery(params || {})}`;
}

export function fetchMidpointMediaHealth(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "ops/health"));
}

export function fetchMidpointMediaHealthHistory(clientViewId, range = "24h") {
  return clientPortalRequest(opsPath(clientViewId, "ops/health/history", { range }));
}

export function fetchMidpointMediaDigitalOcean(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "ops/digitalocean"));
}

export function fetchMidpointMediaOpenProject(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "ops/openproject"));
}

export function fetchMidpointMediaCrmSummary(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "crm/summary"));
}

export function fetchMidpointMediaCrmLeads(clientViewId, params = {}) {
  return clientPortalRequest(opsPath(clientViewId, "crm/leads", params));
}

export function fetchMidpointMediaJobApplications(clientViewId, params = {}) {
  return clientPortalRequest(opsPath(clientViewId, "people/job-applications", params));
}

export function fetchMidpointMediaPeopleDashboard(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "people/dashboard"));
}

export function deleteMidpointMediaJobApplication(clientViewId, leadId) {
  return clientPortalRequest(opsPath(clientViewId, `people/job-applications/${leadId}`), {
    method: "DELETE",
  });
}

export function fetchMidpointMediaCrmLead(clientViewId, leadId) {
  return clientPortalRequest(opsPath(clientViewId, `crm/leads/${leadId}`));
}

export function patchMidpointMediaCrmLead(clientViewId, leadId, payload) {
  return clientPortalRequest(opsPath(clientViewId, `crm/leads/${leadId}`), {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function listMidpointMediaNotificationTemplates(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "notifications/templates"));
}

export function getMidpointMediaNotificationTemplate(clientViewId, templateKey) {
  return clientPortalRequest(
    opsPath(clientViewId, `notifications/templates/${encodeURIComponent(templateKey)}`)
  );
}

export function updateMidpointMediaNotificationTemplate(clientViewId, templateKey, payload) {
  return clientPortalRequest(
    opsPath(clientViewId, `notifications/templates/${encodeURIComponent(templateKey)}`),
    {
      method: "PUT",
      body: JSON.stringify(payload),
    }
  );
}

export function previewMidpointMediaNotificationTemplate(clientViewId, templateKey, payload = {}) {
  return clientPortalRequest(
    opsPath(clientViewId, `notifications/templates/${encodeURIComponent(templateKey)}/preview`),
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

export function resetMidpointMediaNotificationTemplate(clientViewId, templateKey) {
  return clientPortalRequest(
    opsPath(clientViewId, `notifications/templates/${encodeURIComponent(templateKey)}/reset`),
    { method: "POST" }
  );
}

export function listMidpointMediaNotificationSends(clientViewId, params = {}) {
  return clientPortalRequest(opsPath(clientViewId, "notifications/sends", params));
}

export function getMidpointMediaNotificationSend(clientViewId, sendId) {
  return clientPortalRequest(
    opsPath(clientViewId, `notifications/sends/${encodeURIComponent(sendId)}`)
  );
}
